/*******************************************************************************
 * Copyright (c) 2022 THERAYTEK
 *
 * All rights reserved.
 *
 * Contributors:
 *   James Worthington - Initial implementation
 *   
 *   Amina Rais - Massive Improvements
 *
 * Version: 1
 *
 *******************************************************************************/

import * as types from '../types';

import { getUserInfo } from './user';

import { history } from '../../helpers';
export const initializedSuccess = () => ({
  type: types.app.INITIALIZED_SUCCESS
});

export const initializedError = () => ({ type: types.app.INITIALIZED_ERROR });

export const initializeApp = () => (dispatch, getState) => {
  dispatch(initializedSuccess());
};
